import { useEffect, useState } from "react";

export const useScroll = ({ start, end }: { start: string; end: string }) => {
    const [positionY, setPositionY] = useState<string>(start);

    useEffect(() => {
        const handleScroll = () => {
            const { scrollY } = window;

            if (scrollY) {
                setPositionY(end);
            } else {
                setPositionY(start);
            }
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return { positionY };
};
